/* GTG UX staging 2026-09-18: mobile collection description Read more / Show less
   One HTML source (.collection-hero__description); CSS clamps; JS toggles.
   Hardened: scrollHeight under -webkit-line-clamp is flaky (e.g. GTG Minis
   single <p> with meta/bis_size markup) — fall back to text-length heuristic. */
(function () {
  var SELECTOR = '.collection-hero__description';
  var CLAMP = 'gtg-desc--needs-clamp';
  var EXPANDED = 'gtg-desc--expanded';
  /* ~3 mobile lines at ~50–55 chars; Minis ~280 chars / Monsters longer */
  var CHAR_THRESHOLD = 160;
  var MOBILE_MQ = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function ensureToggle(desc) {
    var next = desc.nextElementSibling;
    if (next && next.classList && next.classList.contains('gtg-desc-toggle')) {
      return next;
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gtg-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle(EXPANDED);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
    desc.insertAdjacentElement('afterend', btn);
    return btn;
  }

  function normalizedText(desc) {
    return (desc.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function heuristicNeedsClamp(desc) {
    var text = normalizedText(desc);
    if (text.length >= CHAR_THRESHOLD) return true;
    /* multiple block-level / break children → likely multi-line RTE */
    var blocks = desc.querySelectorAll('p, li, br, div, h1, h2, h3, h4, h5, h6');
    if (blocks.length >= 2) return true;
    var lines = (desc.innerText || '')
      .split(/\n+/)
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
    if (lines.length >= 4) return true;
    return false;
  }

  function measureOverflow(desc) {
    /* Force layout after clamp class applied */
    void desc.offsetHeight;
    var needs = desc.scrollHeight > desc.clientHeight + 2;
    if (!needs) {
      var kids = desc.children;
      var i;
      for (i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el.scrollHeight > el.clientHeight + 2) {
          needs = true;
          break;
        }
      }
    }
    if (!needs) {
      var p = desc.querySelector('p');
      if (p && p.scrollHeight > p.clientHeight + 2) needs = true;
    }
    return needs;
  }

  function measureNeedsClamp(desc) {
    desc.classList.add(CLAMP);
    desc.classList.remove(EXPANDED);
    var needs = measureOverflow(desc);
    /* Known flaky: -webkit-line-clamp often yields scrollHeight === clientHeight */
    if (!needs && heuristicNeedsClamp(desc)) needs = true;
    return needs;
  }

  function resetToggle(btn) {
    btn.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
  }

  function initOne(desc) {
    if (!desc || !desc.textContent || !desc.textContent.trim()) return;

    var btn = ensureToggle(desc);

    /* Desktop: never clamp / never show toggle (CSS also hides) */
    if (!isMobile()) {
      desc.classList.remove(CLAMP, EXPANDED);
      resetToggle(btn);
      desc.dataset.gtgDescInit = '1';
      return;
    }

    var wasExpanded = desc.classList.contains(EXPANDED);
    var needs = measureNeedsClamp(desc);

    if (!needs) {
      desc.classList.remove(CLAMP, EXPANDED);
      resetToggle(btn);
      desc.dataset.gtgDescInit = '1';
      return;
    }

    btn.hidden = false;
    if (wasExpanded) {
      desc.classList.add(EXPANDED);
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = 'Show less';
    } else {
      desc.classList.remove(EXPANDED);
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Read more';
    }
    desc.dataset.gtgDescInit = '1';
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll(SELECTOR).forEach(function (desc) {
      delete desc.dataset.gtgDescInit;
      initOne(desc);
    });
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });

  window.addEventListener('load', function () {
    init(document);
  });

  /* Re-evaluate when crossing mobile/desktop breakpoint */
  var mq = window.matchMedia(MOBILE_MQ);
  function onMqChange() {
    init(document);
  }
  if (mq.addEventListener) {
    mq.addEventListener('change', onMqChange);
  } else if (mq.addListener) {
    mq.addListener(onMqChange);
  }
})();
/* resave 2026-10-12 */
